import { DATA_LAYER_SCREEN_TYPES } from '../constants'
import { SmdlScreen } from '../types'
import cloneDeep from 'lodash/cloneDeep'

export const removeTrailingSlash = (path: string) => {
  if (path.endsWith('/')) {
    return path.substring(0, path.length - 1)
  }
  return path
}

const SAFE_PATHNAME_PATTERN = /^[a-zA-Z0-9\-._~!$&'()*+,;=:@/%]*$/

export const sanitizePathname = (path: string): string => {
  if (!SAFE_PATHNAME_PATTERN.test(path)) {
    return '/'
  }
  return path
}

export interface PathMapEntry {
  name?: string
  namePrefix?: string
  type: DATA_LAYER_SCREEN_TYPES
}

export const findPageAttrs = ({
  path,
  pathMap,
  regexPathMap,
}: {
  path: string
  pathMap: Record<string, PathMapEntry>
  regexPathMap: Record<string, PathMapEntry>
}): SmdlScreen | undefined => {
  const pathList = Object.keys(pathMap)
  const strictMatch = pathList.find((p) => p === path)
  if (strictMatch !== undefined) {
    return pathMap[strictMatch as keyof typeof pathMap]
  }

  const regexPathList = Object.keys(regexPathMap)
  const regexMatch = regexPathList.find((regexPath) => {
    try {
      // regexPath comes from a hardcoded app config (not user input); path is sanitized via sanitizePathname
      // no-dd-sa typescript-browser-security/detect-non-literal-regexp
      // no-dd-sa:typescript-node-security/detect-non-literal-regexp
      // no-dd-sa:typescript-browser-security/regexp-non-literal
      const re = new RegExp(regexPath, 'i') // nosemgrep: detect-non-literal-regexp
      return re.test(path)
    } catch {
      return false
    }
  })
  if (regexMatch) {
    const regexPathObject = cloneDeep(
      regexPathMap[regexMatch as keyof typeof regexPathMap] as SmdlScreen
    )
    const { namePrefix } = regexPathObject
    if (namePrefix) {
      // regexMatch comes from a hardcoded app config (not user input); safe to reuse as a literal-equivalent pattern
      // no-dd-sa typescript-browser-security/detect-non-literal-regexp
      // no-dd-sa:typescript-node-security/detect-non-literal-regexp
      // no-dd-sa:typescript-browser-security/regexp-non-literal
      const regExpExecArray = new RegExp(regexMatch, 'i').exec(path) // nosemgrep: detect-non-literal-regexp
      const match = regExpExecArray?.[1]
      regexPathObject.name = `${namePrefix}${match}`
      // Get rid of it otherwise this field will be sent to dmpg
      delete regexPathObject.namePrefix
    }
    return regexPathObject
  }
  return undefined
}
